import { produce } from "immer";
import { tProfileAction, tProfileState, tSetProfilePreviewAction } from "./types";

const kDefaultState: tProfileState = {
  repProfilePreview: undefined,
};

const handleSetProfilePreview = (draft: tProfileState, action: tSetProfilePreviewAction): tProfileState => {
  draft.repProfilePreview = action.payload.rep;
  return draft;
};

const handleClearProfilePreview = (draft: tProfileState): tProfileState => {
  draft.repProfilePreview = undefined;
  return draft;
};

export const ProfileReducer = produce((draft: tProfileState = kDefaultState, action: tProfileAction): tProfileState => {
  switch (action.type) {
    case "SET_PROFILE_PREVIEW":
      return handleSetProfilePreview(draft, action);
    case "CLEAR_PROFILE_PREVIEW":
      return handleClearProfilePreview(draft);
    default:
      return draft;
  }
});
